<template></template>

<script>
  import { mapGetters } from 'vuex'
  import 'jquery-validation'
  import 'jquery-validation/dist/additional-methods.js'
  
  export default {
    name: 'RegisterAcademicTraining',
    computed: {
      ...mapGetters(['user']),
    },
    mounted() {
      /**
       * Init Select2 for levels
       */
      const levels = $('.search-levels')
      
      levels.select2({
        language: {
          noResults: function() {
            return 'Aún no ha ingresado ningún valor'
          },
        },
      })

      /**
       * Init Select2 for countries
       */
      const countries = $('.search-country')
      
      countries.select2({
        language: {
          noResults: function() {
            return 'Aún no ha ingresado ningún valor'
          },
        },
      })
      
      /**
       * Init JQuery validation
       */
      $(() => {
        $(document).ready(function() {
          $('.form').validate({
            ignore: [],
            highlight: function(element, errorClass, validClass) {
              $(element).addClass('is-invalid')
            },
            unhighlight: function(element, errorClass, validClass) {
              $(element).removeClass('is-invalid')
            },
            errorPlacement: function(label, element) {
              if(element.hasClass('select2-input')) {
                label.insertAfter(element.siblings('span.select2'))
              }
              else {
                label.insertAfter(element)
              }
              
              label.addClass('invalid-feedback')
            },
            rules: {
              level: {
                required: true,
              },
              institution: {
                required: true,
              },
              initials: {
              
              },
              country_id: {
                required: true,
              },
              entity_select: {
                required: function () {
                  return $('select[name="country_id"] option:selected').text() === 'México (Estados Unidos Mexicanos)'
                },
              },
              entity: {
                required: function () {
                  return $('select[name="country_id"] option:selected').text() !== 'México (Estados Unidos Mexicanos)'
                },
              },
              city: {
              
              },
              start_year: {
                required: true,
              },
              end_year: {
                required: true,
              },
              status: {
                required: true,
              },
            },
            messages: {
              level: {
                required: 'Este campo es requerido.',
              },
              institution: {
                required: 'Este campo es requerido.',
              },
              inititals: {
              
              },
              country_id: {
                required: 'Este campo es requerido.',
              },
              entity_select: {
                required: 'Este campo es requerido.',
              },
              entity: {
                required: 'Este campo es requerido.',
              },
              city: {
                required: 'Este campo es requerido.',
              },
              start_year: {
                required: 'Este campo es requerido.',
              },
              end_year: {
                required: 'Este campo es requerido.',
              },
              status: { required: 'Seleccione un estatus'}
            },
            submitHandler(form) {
              $('#btn-save, #btn-cancel').prop('disabled', true)
              $('#btn-save').find('.spinner-border').removeClass('d-none')
              
              form.submit()
            },
          })
        })

        $('select[name="country_id"]').on('change', function() {
          toogleEntityInput()
        })

        toogleEntityInput()

        function toogleEntityInput() {
          let selected = $('select[name="country_id"] option:selected').text()

          if (selected === 'México (Estados Unidos Mexicanos)') {
            $('#entity-select').removeClass('d-none')
            $('#entity-text').addClass('d-none')
          } else {
            $('#entity-select').addClass('d-none')
            $('#entity-text').removeClass('d-none')
          }
        }
      })
    },
  }
</script>
